import { Typography } from '@mui/material';
import { Box } from '@mui/system';

function Footer() {
  return (
    <Box className="footerBox">
      <Typography variant="body2" className="footerContent">
        Copyright © 2026 &nbsp;
        {/* <a href="https://www.realvalue.loans/" target="_blank">
          Real Value
        </a> */}
        <a href="https://www.kalolytic.com/" target="_blank">
          Kalolytic Solutions
        </a>
        {/* <a href="http://kalolytic.com/" target="_blank">
          Kalolytic
        </a> */}
        {/* <a href="https://www.realvalue.loans/" target="_blank">
        Kalolytic Solutions Pvt Ltd
        </a> */}
        . All rights reserved.
      </Typography>
    </Box>
  );
}

export default Footer;
